// GROQ queries for fetching portfolio data from Sanity

export const QUERIES = {
  // Individual queries
  person: `*[_type == "person"][0]`,
  projects: `*[_type == "project"] | order(order asc)`,
  certifications: `*[_type == "certification"] | order(order asc)`,
  education: `*[_type == "education"] | order(order asc)`,
  workExperience: `*[_type == "workExperience"] | order(order asc)`,
  freelance: `*[_type == "freelance"][0]`,

  // Combined query for initial load (reduces API calls)
  portfolioData: `{
    "person": *[_type == "person"][0],
    "projects": *[_type == "project"] | order(order asc),
    "certifications": *[_type == "certification"] | order(order asc),
    "education": *[_type == "education"] | order(order asc),
    "workExperience": *[_type == "workExperience"] | order(order asc),
    "freelance": *[_type == "freelance"][0]
  }`,
};
